var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.555 15.687 9 1.104l8.446 14.583zm2.153-1.25h12.584L9 3.604zM9 13.444q.285 0 .48-.194a.65.65 0 0 0 .193-.48q0-.285-.193-.48a.65.65 0 0 0-.48-.193q-.285 0-.48.194a.65.65 0 0 0-.193.48q0 .285.194.48a.65.65 0 0 0 .48.193m-.625-2.18h1.25V7.097h-1.25z"
  })));
};
export default SvgExclamationTriangle;